export function getCookie(cookieName: string) {
	const cookie = {};
	document.cookie.split(';').forEach((el) => {
		const [key, value] = el.split('=');
		cookie[key.trim()] = value;
	});
	return cookie[cookieName];
}

export function setCookie(cookieName: string, cookieValue: string, expirationDays: number) {
	let expiryDate = '';
	if (expirationDays) {
		const date = new Date();
		date.setTime(date.getTime() + expirationDays * 24 * 60 * 60 * 1000);
		expiryDate = `; expires= "${date.toUTCString()}`;
	}

	document.cookie = `${cookieName}=${cookieValue}${expiryDate}; path=/ `;
}
